module.exports = __webpack_public_path__ + "static/img/apple.bdd32f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/apple.png
// module id = 5hao
// module chunks = 0